import $ from 'jquery';
import VueHtmlToPaper from 'vue-html-to-paper';
import Vue from 'vue';
import { convertDateToDdMmYyyy } from '@/function/function.js';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://etgmtogo.com/style.css',
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    ]
}

Vue.use(VueHtmlToPaper, options);

export default {
    name: 'resultat-biochimie',
    components: {
        EnteteBonEtFacture
    },
    props: [],
    data () {
        return {
            l_resultats: [],
            date_resultat: ''           //  Date d'enregistrement du résultat
        }
    },
    computed: {

    },
    mounted () {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());  // Temporaire. NB : A remplacer par la date du resultat

        this.l_resultats = [
            {
               "analyse": "GLYCEMIE",
               "resultat": "",
               "reference": [
                   "0,70 – 1,10g/l"
                ]
            },
            {
                "analyse": "UREMIE / AZOTEMIE",
                "resultat": "",
                "reference": [
                    "0,10 – 0,40g/l"
                ]
            },
            {
                "analyse": "CREATININE",
                "resultat": "",
                "reference": [
                    "H : 7 – 14 mg /l",
                    "F: 6 – 11 mg /l",
                    "Enf :  4 – 6  mg/l"
                ]
            },
            {
                "analyse": "TRANSAMINASES TGO",
                "resultat": "",
                "reference": [
                    "H : ≤  38 u/l",
                    "F : ≤  31 u/l",
                ]
            },
            {
                "analyse": "TRANSAMINASES TGP",
                "resultat": "",
                "reference": [
                    "H : ≤  40 u/l",
                    "F : ≤  32 u/l"
                ]
            },
        ]
    },
    methods: {
        printResultatBiochimie() {
            this.$htmlToPaper('print_biochimie_result')
        }
    }
}


